import { HttpHelper } from './HttpHelper';
import { BackupConfig } from '../Models/Backup/BackupConfig';
import { Backup } from '../Models/Backup/Backup';
import { Language } from '../Models/Language/Language';
import { authService } from '../App';

export abstract class LanguageHelper {
  private static baseUrl = HttpHelper.GetUrlBaseApi() + 'api/' + 'Language';

  public static async GetAvailableLanguages() {
    var urlForRequest = this.baseUrl + '/AvailableLanguages';
    return await HttpHelper.GetRequestForApi<Language[]>(urlForRequest);
  }

  public static async GetLanguages() {
    var urlForRequest = this.baseUrl + '/LanguagesWithTranslations';
    return await HttpHelper.GetRequestForApi<Language[]>(urlForRequest);
  }

  public static async ReplaceLanguages(language: Language[]) {
    var token = authService.GetToken();
    var urlForRequest = this.baseUrl + '/' + 'ReplaceAll';
    return await HttpHelper.PostRequestForApi<Language>(
      urlForRequest,
      language,
      token,
    );
  }

  public static async AddLanguage(item: Language, token: string) {
    var urlForRequest = this.baseUrl;
    return await HttpHelper.PostRequestForApi<Language>(
      urlForRequest,
      item,
      token,
    );
  }

  public static async UpdateLanguage(item: Language, token: string) {
    var urlForRequest = this.baseUrl + '/' + item.id;
    return await HttpHelper.UpdateRequestForApi<Language>(
      urlForRequest,
      item,
      token,
    );
  }

  public static async DeleteLanguage(item: Language, token: string) {
    var urlForRequest = this.baseUrl + '/' + item.id;
    return await HttpHelper.DeleteRequestForApi(urlForRequest, item, token);
  }

  public static async ExportLanguages(items: Language[], token: string) {
    var urlForRequest = this.baseUrl + '/ExportToJSON';
    await HttpHelper.PostRequestForApiForFile(urlForRequest, items, token);
  }

  public static async ImportLanguages(items: Language[], token: string) {
    return this.baseUrl + 'UploadLanguages';
  }
}
